"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ic_Black__Tranparant", {
  enumerable: true,
  get: function get() {
    return _ic_black__tranparant.default;
  }
});
Object.defineProperty(exports, "ic_Horizontal__Black", {
  enumerable: true,
  get: function get() {
    return _ic_horizontal__black.default;
  }
});
Object.defineProperty(exports, "ic_Horizontal__Red__SpeechmarkWhite", {
  enumerable: true,
  get: function get() {
    return _ic_horizontal__red__speechmarkwhite.default;
  }
});
Object.defineProperty(exports, "ic_Horizontal__White__Speechmarkred", {
  enumerable: true,
  get: function get() {
    return _ic_horizontal__white__speechmarkred.default;
  }
});
Object.defineProperty(exports, "ic_Horizontal__White", {
  enumerable: true,
  get: function get() {
    return _ic_horizontal__white.default;
  }
});
Object.defineProperty(exports, "ic_Red", {
  enumerable: true,
  get: function get() {
    return _ic_red.default;
  }
});
Object.defineProperty(exports, "ic_Vertical__Black", {
  enumerable: true,
  get: function get() {
    return _ic_vertical__black.default;
  }
});
Object.defineProperty(exports, "ic_Vertical__Red__SpeechmarkWhite", {
  enumerable: true,
  get: function get() {
    return _ic_vertical__red__speechmarkwhite.default;
  }
});
Object.defineProperty(exports, "ic_Vertical__White__SpeechmarkRed", {
  enumerable: true,
  get: function get() {
    return _ic_vertical__white__speechmarkred.default;
  }
});
Object.defineProperty(exports, "ic_Vertical__White", {
  enumerable: true,
  get: function get() {
    return _ic_vertical__white.default;
  }
});
Object.defineProperty(exports, "ic_White__Transparant", {
  enumerable: true,
  get: function get() {
    return _ic_white__transparant.default;
  }
});
Object.defineProperty(exports, "ic_White", {
  enumerable: true,
  get: function get() {
    return _ic_white.default;
  }
});

var _ic_black__tranparant = _interopRequireDefault(require("./ic_black__tranparant"));

var _ic_horizontal__black = _interopRequireDefault(require("./ic_horizontal__black"));

var _ic_horizontal__red__speechmarkwhite = _interopRequireDefault(require("./ic_horizontal__red__speechmarkwhite"));

var _ic_horizontal__white__speechmarkred = _interopRequireDefault(require("./ic_horizontal__white__speechmarkred"));

var _ic_horizontal__white = _interopRequireDefault(require("./ic_horizontal__white"));

var _ic_red = _interopRequireDefault(require("./ic_red"));

var _ic_vertical__black = _interopRequireDefault(require("./ic_vertical__black"));

var _ic_vertical__red__speechmarkwhite = _interopRequireDefault(require("./ic_vertical__red__speechmarkwhite"));

var _ic_vertical__white__speechmarkred = _interopRequireDefault(require("./ic_vertical__white__speechmarkred"));

var _ic_vertical__white = _interopRequireDefault(require("./ic_vertical__white"));

var _ic_white__transparant = _interopRequireDefault(require("./ic_white__transparant"));

var _ic_white = _interopRequireDefault(require("./ic_white"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }